/**
 * @param {RegisteredCustomer} [customer]
 * @returns {Date | null}
 */
export function lastVisitedAt(customer) {
  if (customer == null) return null;
  return customer.transactions
    .filter((tx) => tx.reason === 3) // Time was payed
    .map((tx) => new Date(tx.createdAt))
    .find(() => true); // Valid cause transactions already sorted desc by date
}

export default {
  lastVisitedAt,
};
